import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import { useContext, useState } from "react";
import { Login, Register } from "../../../../services/LoginService";
import LoginModel from "../../../../models/Login";
import { AuthenticationContext } from "../../../controls/auth/AuthenticationWrap";
import useLogin from "./useLogin";

export default function useRegister(props: {
	setOpenDialog: (value: boolean) => void;
	setLoading: (value: boolean) => void;
}) {
	const { openAlertDialog } = useAlertDialog();
	const [dataLogin, setDataLogin] = useState<LoginModel>();
	const [errorMess, setErrorMess] = useState("");
	// const backPath = getBackPath(search);
	const authCtx = useContext(AuthenticationContext);
	const { onLoginSuccess } = authCtx || {};
	const { doLogin } = useLogin({});
	const doRegister = async (
		name: string,
		email: string,
		password: string,
		confirmPassword: string,
		communicationId: string,
		phone: string
	) => {
		try {
			let res = await Register(name, email, password, confirmPassword, communicationId, phone);
			props.setLoading?.(false);
			doLogin(email || "", password);
			props.setOpenDialog(false);
		} catch (error: any) {
			openAlertDialog?.(AlertType.Fail, error?.response.data?.message || "An error has occurred!", () => {
				props.setLoading?.(false);
			});
			setErrorMess(error?.response.data.message || "An error has occurred!");
		} finally {
		}
	};

	return {
		doRegister,
		dataLogin,
		errorMess,
	};
}
